import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Slider from "@mui/material/Slider";
import React, { useEffect, useState, useRef } from "react";
import { Row } from "react-bootstrap";
import { SliderPicker } from "react-color";
import { useTranslation } from "react-i18next";
import { Layer, Line, Stage, Text } from "react-konva";
import colorPallete from "../../Assets/Images/colorPallete.svg";
import eraser from "../../Assets/Images/eraser.svg";
import pencil from "../../Assets/Images/pencil.svg";
import reset from "../../Assets/Images/reset.svg";
import time from "../../Assets/Images/time.svg";
import "../../Assets/Styles/pages/signature.scss";
import CancelButton from "../Cancel_button/Cancel_button";

import _ from "lodash";
import helper_functions from "../../Config/helper_functions";
import { canvasPreview } from "../Cropper/canvasPreview";
import IconsRow from "./iconsRow";
import ButtonRounded from "./button";

const Signature = ({
  openSignature,
  setActive,
  setOpenSignature,
  onSignatureApply,
}) => {
  const [size, setSize] = useState(5);
  const { t } = useTranslation();
  const [color, setColor] = useState("#00000");
  const [dateColor, setDateColor] = useState("#00000");
  const [colorShow, setColorShow] = useState(false);
  const [tool, setTool] = React.useState("pen");
  const [date, setDate] = React.useState(null);
  const [lines, setLines] = React.useState([]);
  const [drawn, setDrawn] = React.useState(false);
  const isDrawing = React.useRef(false);
  const stageRef = React.useRef();
  const textRef = React.useRef();
  const [arr_line, setArr_line] = useState([]);
  const [xCords, setXCords] = useState(0);
  const [yCords, setYCords] = useState(0);
  const [canvasWidth, setWidth] = useState(0);
  const [canvasHeight, setHeight] = useState(0);

  // ************************************ \\
  const [imgSrc, setImgSrc] = useState("");
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState({});

  // ***************************** \\

  useEffect(() => {}, [canvasWidth, canvasHeight]);
  const handleClose = () => {
    setOpenSignature(false);
    setActive("");
    setLines([]);
    setArr_line([]);
    setCompletedCrop({});
    setDate(null);
  };

  useEffect(() => {
    setWidth(window.innerWidth / 2.35);
    setHeight(window.innerWidth / 2.35 / 2.35);
    setLines([]);
    return () => {
      setArr_line([]);
      setLines([]);
    };
  }, [window.innerHeight, window.innerWidth]);

  useEffect(() => {
    if (textRef.current) {
      setXCords(canvasWidth - textRef.current.width());
      setYCords(canvasHeight - textRef.current.height());
    }
  }, [date]);

  function downloadImage(uri) {
    handleClose();
    onSignatureApply(uri);
    setOpenSignature(false);
  }
  const dateSet = () => {
    setDateColor(color);
    if (!date) {
      let text = new Date();
      let hrs, mins, secs, format;
      if (text.getHours() > 12) {
        hrs = text.getHours() - 12;
        format = "pm";
      } else {
        hrs = text.getHours();
        format = "am";
      }
      mins = text.getMinutes();
      secs = text.getSeconds();
      if (hrs < 10) hrs = "0" + hrs;
      if (mins < 10) mins = "0" + mins;
      if (secs < 10) secs = "0" + secs;
      setDate(
        text.getDate() +
          "/" +
          (text.getMonth() + 1) +
          "/" +
          text.getFullYear() +
          " " +
          hrs +
          ":" +
          mins +
          ":" +
          secs +
          " " +
          format
      );
    } else setDate(null);
  };

  const Apply = async () => {
    if (arr_line.length && stageRef.current) {
      // Find the max and min x and y values
      const maxX = _.maxBy(arr_line, "x");
      const maxY = _.maxBy(arr_line, "y");
      const minX = _.minBy(arr_line, "x");
      const minY = _.minBy(arr_line, "y");

      // Get the image data from the canvas
      const image_data = await stageRef.current.toDataURL({
        // mimeType: "image/jpeg",
        quality: 1,
        pixelRatio: 5,
      });
      setImgSrc(image_data);

      // Calculate the crop coordinates and dimensions
      let cropProps;
      if (date) {
        cropProps = {
          unit: "px",
          x: (minX.x - 5) * 5,
          y: (minY.y - 5) * 5,
          width: (canvasWidth - minX.x + 5) * 5,
          height: (canvasHeight - minY.y + 5) * 5,
        };
      } else {
        cropProps = {
          unit: "px",
          x: (minX.x - 5) * 5,
          y: (minY.y - 5) * 5,
          width: (maxX.x - minX.x + 10) * 5,
          height: (maxY.y - minY.y + 10) * 5,
        };
      }

      // Set the crop properties
      setCompletedCrop(cropProps);
      setDrawn(!drawn);
    }
  };

  helper_functions.useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          downloadImage
        );
      }
    },
    100,
    [completedCrop]
  );
  const handleMouseDown = (e) => {
    isDrawing.current = true;
    const pos = e.target.getStage().getPointerPosition();
    setLines([
      ...lines,
      { tool, points: [pos.x, pos.y], colors: color, stroke: size },
    ]);
  };

  const handleMouseMove = (e) => {
    if (!isDrawing.current) return;

    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    if (point) {
      setArr_line((prev) => [...prev, point]);

      const lastLine = lines[lines.length - 1];
      if (lastLine) {
        lastLine.points = [...lastLine.points, point.x, point.y];
        setLines((prev) => [...prev.slice(0, -1), lastLine]);
      }
    }
  };

  const handleMouseUp = () => {
    isDrawing.current = false;
  };
  const handleChangeComplete = (data) => {
    setColor(data.hex);
  };

  const handleMouseLeave = () => {
    if (isDrawing.current) {
      isDrawing.current = false;
    }
  };

  return (
    <Modal
      open={openSignature}
      onClose={() => {
        handleClose();
        setActive("");
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={openSignature}>
        <div className="signature_model">
          <div className="d-none" id="container"></div>
          <CancelButton close={() => handleClose()} />
          <Row
            className=" 
        productSansBold text_18 justify-content-center"
          >
            {t("Signature.DrawSignature")}
          </Row>
          <Row
            className=" 
        productSansLight text_15 mb-4 justify-content-center"
          >
            {t("Signature.DrawSignature_disc")}
          </Row>
          <Row className="top_menu pt-2 text_15 productSansLight justify-content-center">
            <IconsRow
              icon={pencil}
              text={"Signature.Pencil"}
              onClick={() => {
                setTool("pen");
                setColorShow(false);
              }}
            />

            <IconsRow
              icon={colorPallete}
              text={"Signature.Color"}
              onClick={() => {
                setColorShow(true);
              }}
            />

            <IconsRow
              icon={eraser}
              text={"Signature.Eraser"}
              onClick={() => {
                setTool("eraser");
                setColorShow(false);
              }}
            />
            <IconsRow
              icon={time}
              text={"Signature.Time"}
              onClick={() => {
                dateSet();
              }}
            />
          </Row>
          {tool ? (
            <>
              <Row
                className={`${
                  !colorShow ? "" : "d-none"
                } m-0 my-4 h_2_rem px_7 justify-content-center stroke`}
              >
                <Slider
                  size="medium"
                  value={size}
                  min={1}
                  max={10}
                  onChange={(e, value) => setSize(value)}
                />
              </Row>
              <Row
                className={`${
                  colorShow ? "" : "d-none"
                } m-0 my-4 h_2_rem px_7 justify-content-center stroke`}
              >
                <SliderPicker color={color} onChange={handleChangeComplete} />
              </Row>
            </>
          ) : null}
          {
            <Row className="canvas_bg m-0 p-0 d-flex justify-content-center align-items-center">
              <div className="resetInsideCanvas p-0 m-0">
                <img
                  onClick={() => {
                    setLines([]);
                    setDate(null);
                    setColor("#000");
                    setDateColor("#000");
                  }}
                  src={reset}
                  alt="Reset btn"
                />
              </div>
              <Stage
                className="centerline m-0 p-0 w-auto"
                width={canvasWidth}
                height={canvasHeight}
              >
                <Layer>
                  <Line
                    x={canvasWidth / 2} // Set the horizontal position to the middle of the canvas
                    y={canvasHeight / 2} // Set the vertical position to the middle of the canvas
                    points={[-canvasWidth / 2.25, 0, canvasWidth / 2.25, 0]} // Start and end the line in the center
                    stroke="#000" // Line color
                    strokeWidth={1} // Line width
                    opacity={0.5} // Line opacity
                    dash={[5, 5]} // Dash pattern
                  />
                </Layer>
              </Stage>
              <Stage
                className="d-flex justify-content-center m-0 p-0 canvas_bg_2"
                ref={stageRef}
                width={canvasWidth}
                height={canvasHeight}
                onMouseDown={handleMouseDown}
                onMousemove={handleMouseMove}
                onMouseup={handleMouseUp}
                onMouseLeave={handleMouseLeave}
              >
                <Layer>
                  {lines?.map((line, i) => (
                    <Line
                      key={i}
                      points={line.points}
                      stroke={line.colors}
                      strokeWidth={line.stroke}
                      tension={0.5}
                      lineCap="round"
                      lineJoin="round"
                      globalCompositeOperation={
                        line.tool === "eraser"
                          ? "destination-out"
                          : "source-over"
                      }
                    />
                  ))}
                  <Text
                    ref={textRef}
                    fontFamily={"datefont"}
                    fontSize={25}
                    fill={dateColor}
                    text={date}
                    x={xCords}
                    y={yCords}
                  />
                </Layer>
              </Stage>
            </Row>
          }
          {
            <Row className="canvas_bg d-none justify-content-center">
              {!!completedCrop && (
                <canvas
                  ref={previewCanvasRef}
                  style={{
                    border: "1px solid black",
                    objectFit: "contain",
                    width: completedCrop.width,
                    height: completedCrop.height,
                  }}
                />
              )}
              {
                <img
                  className="d-none"
                  ref={imgRef}
                  alt="Crop me"
                  src={imgSrc}
                />
              }
            </Row>
          }
          <div className="w-100 justify-content-center d-flex align-items-center gap-3">
            <ButtonRounded
              onclick={handleClose}
              text={"Cancel"}
              style={"w_edit_button bg-secondary border-secondary my-3 mb-2"}
            />
            <ButtonRounded
              onclick={Apply}
              text={"Signature.Apply"}
              style={"w_edit_button  my-3 mb-2"}
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default Signature;
